<nav
  class="navbar navbar-expand-lg navbar-absolute bg-primary"
  [class.navbar-transparent]="!isCollapsed()"
  [class.bg-white]="isCollapsed()"
>
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <div class="navbar-toggle">
        <button
          #navbarToggler
          type="button"
          class="navbar-toggler"
          (click)="sidebarToggle()"
          [class.toggled]="isToggled()"
        >
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      @if (showBackBtn()) {
        <button class="btn back-btn" (click)="goBack()">
          <span class="btn-label">
            <i class="now-ui-icons arrows-1_minimal-left"></i>
          </span>
          Indietro
        </button>
      }
      <span class="navbar-brand d-none d-md-block ms-1">{{ title() }}</span>
    </div>
    <button
      class="navbar-toggler"
      type="button"
      (click)="collapse()"
      [attr.aria-expanded]="!isCollapsed()"
      aria-controls="collapseExample"
    >
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="collapseExample" [ngbCollapse]="!isCollapsed()">
      <!--<form>
      <div class="input-group no-border">
        <input
          type="text"
          value=""
          class="form-control"
          placeholder="Search..."
          />
          <div class="input-group-append">
            <div class="input-group-text">
              <i class="now-ui-icons ui-1_zoom-bold"></i>
            </div>
          </div>
        </div>
      </form>-->
      <ul class="navbar-nav">
        <!--<li class="nav-item">
        <a class="nav-link" href="#pablo">
          <i class="now-ui-icons media-2_sound-wave"></i>
          <p><span class="d-lg-none d-md-block">Stats</span></p>
        </a>
      </li>
      <li class="nav-item dropdown" ngbDropdown>
        <a
          class="nav-link dropdown-toggle"
          id="dropdownBasic1"
          ngbDropdownToggle
          >
          <i class="now-ui-icons location_world"></i>
          <p><span class="d-lg-none d-md-block">Some Actions</span></p>
        </a>
        <div
          class="dropdown-menu dropdown-menu-right"
          ngbDropdownMenu
          aria-labelledby="dropdownBasic1"
          >
          <a class="dropdown-item" href="#">Action</a>
          <a class="dropdown-item" href="#">Another action</a>
          <a class="dropdown-item" href="#">Something else here</a>
        </div>
      </li>-->
        <li class="nav-item pointer">
          <a class="nav-link p-0 d-flex align-items-center" (click)="logout()">
            <svg xmlns="http://www.w3.org/2000/svg" width="13.977" height="12.23" viewBox="0 0 13.977 12.23">
              <path
                id="Icon_open-account-logout"
                data-name="Icon open-account-logout"
                d="M5.241,0V1.747H12.23v8.736H5.241V12.23h8.736V0ZM3.494,3.494,0,6.115,3.494,8.736V6.989h6.989V5.241H3.494Z"
                fill="currentColor"
              />
            </svg>
            <span class="ms-2 d-md-block">LOGOUT</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  @if (mobile_menu_visible()) {
    <div id="bodyClick" (click)="sidebarClose()"></div>
  }
</nav>
